/* eslint-disable max-len */
import { request, RespError, handleFormatRes, date2TimestampStr } from '../../utils';
import { QRY_USERACT_PRIZE } from '../../config/url';
/**
 * 处理异常JSON
 * @param data 需要处理的string
 */
function fixInvalidJson(data) {
    let fdata = data.replace(/(\n)/g, '');
    fdata = fdata.replace(/("\[)/g, '[');
    fdata = fdata.replace(/(\]")/g, ']');
    fdata = fdata.replace(/(\]")/g, ']');
    fdata = fdata.replace(/"\{"/g, '{"'); // 这里的替换，把extension变成了object
    fdata = fdata.replace(/"\}"/g, '"}');
    return fdata;
}
// 需要转成 int 型的 key 数组
const needParseIntKey = ['amt', 'refAmt', 'state'];
// 需要转成 date 型的 key 数组
const needParseDateKey = ['actTime', 'reverseTime'];
/**
 * 查询用户参与活动记录
 *
 * 接口地址：`/app/promotion/prom_qry_useract_prize.cgi`
 *
 * @param actListid 活动id（密文）
 * @returns
 */
export async function qryUseractPrize({ actListid, offset, limit, startTime, endTime }) {
    try {
        // 参数格式化
        let params = {
            t: new Date().getTime(),
            act_listid: actListid,
        };
        if (offset || offset === 0) {
            params = Object.assign({}, params, { offset });
        }
        if (limit || limit === 0) {
            params = Object.assign({}, params, { limit });
        }
        if (startTime) {
            params = Object.assign({}, params, {
                start_time: date2TimestampStr(startTime),
            });
        }
        if (endTime) {
            params = Object.assign({}, params, {
                end_time: date2TimestampStr(endTime),
            });
        }
        // 接口请求
        const result = await request.get(QRY_USERACT_PRIZE, {
            params,
            transformResponse: [
                function (data) {
                    const fdata = fixInvalidJson(data);
                    return JSON.parse(fdata);
                },
            ],
        });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({ result, needParseIntKey, needParseDateKey });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
